import { Response } from '@marketplace-web/shared/api-client'

import { CustomShipmentConfigResp } from 'types/api/response/custom-shipment-config-resp'

import { transformCustomShipmentDto } from 'data/transformers/shipment-custom-config'

export const transformGetCustomShipmentConfig = (response: Response<CustomShipmentConfigResp>) =>
  transformCustomShipmentDto(response.custom_shipment_configuration)
